import {
  Component,
  Renderer
} from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  ViewController,
  LoadingController,
  Events,
  AlertController
} from 'ionic-angular';
import {
  HistoricalService
} from '../../providers/historical.service';
import {
  Subscription
} from "rxjs";
import {
  MapService
} from "../../utils/map.service";
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import 'leaflet';
import {CalendarComponentOptions, CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import {
  CalendarModalPage
} from './calendar-modal/calendar-modal';
import {
  RealTimeService
} from '../../providers/real-time.service';
import {
 GlobalService
} from "../../providers/global.config";
import {
  DataManagementService
} from "../../providers/data-management.service";
import {
  GeocodingService
} from '../../utils/geocoding.service';
import {
  PathsList
} from '../paths-list/paths-list';
import {
  StopList
} from './../stop-list/stop-list';
import {
  Mileage,Path
} from './../../objects/real-time';
import { DatePipe } from '@angular/common';
import {
  LeafletmapPage
} from '../../pages/leafletmap/leafletmap';

@Component({
  selector: 'page-historical-form',
  templateUrl: 'historical-form.html',
})
export class HistoricalForm {

  pathClicked: Path;
  startdate : Date = new Date(Date.now() - 24 * 60 * 60 * 1000 * 2);
  enddate : Date = new Date(); 
  allGroups: Subscription;
  selectedDeviceId: any;
  groups: any[];
  selectedGroup: any;
  selectedGroupId: any;
  case0 : boolean = true;
  case1 : boolean = false;
  case2: boolean = false;
  loader: any;
  list: string = "trajet";
  section: string = 'trajet';
  ListOrMapKilo: string = 'listek';
  ListOrMapArret:string = 'listea';
  ListOrMapTrajet: string = 'listet';
  groupe : any;
  matricule: any;
  myCalendar : any;
  data : any[];
  data2 : any[];
  vehicules : any[];
  allPaths: Subscription;
  allMileages : Subscription;
  allStops : Subscription;
  pathpoirealtime: boolean = false;
  pathDrawn: boolean = false;
  previousPathdrawn: boolean = false;
  pathDraw: boolean = false;
  history:boolean=false;
  paths: any[] = [];
  initialized:boolean = false;
  defaultLoading:boolean = false;
  isCalled:boolean = false;
  stops: any[] = [];
  //AllPaths: any[] = [];
  mileages: Mileage[] = [];
  totalMileage: Mileage;
  selectedV : any;

  startdateShown : string;
  startmonthShown : string;
  startyearShown: string;
  enddateShown : string;
  endmonthShown : string;
  endyearShown : string;
imagesDir = this.globalService.getimagesDir();
imagesPOIDir = this.globalService.getimagesPOIDir();

  constructor(private historicalService: HistoricalService,
   public viewCtrl: ViewController,
    public navCtrl: NavController,
     public navParams: NavParams,
      public loadingCtrl: LoadingController,
      public events: Events,
      public mapService: MapService,
      public modalCtrl: ModalController,
      private realTimeService: RealTimeService,
      private dataManagementService: DataManagementService,
      private geocodingService: GeocodingService,
      private alertCtrl: AlertController,
       private globalService : GlobalService
      ) {

 this.startdateShown = this.getStartDate(this.startdate.getDate());
          this.startmonthShown = this.getStartMonth(this.startdate.getMonth()+1);
          this.startyearShown = this.getStartYear(this.startdate.getUTCFullYear());
          this.enddateShown = this.getEndDate(this.enddate.getDate());
          this.endmonthShown = this.getEndMonth(this.enddate.getMonth()+1);
          this.endyearShown = this.getEndYear(this.enddate.getUTCFullYear());



    events.subscribe('changeToMap', x => {
      if (x) {
        this.ListOrMapTrajet = "mapt";
      }
    });

//changeToMapStop
 events.subscribe('changeToMapStop', x => {
      if (x) {
        this.ListOrMapArret = "mapa";
      }
    });

//changeToMapKilo
 events.subscribe('changeToMapKilo', x => {
      if (x) {
        this.ListOrMapKilo = "mapk";
      }
    });


     events.subscribe('TrajetList', () => {
    this.publishPathTrajetlist();
});

        events.subscribe('StopList', () => {
    this.publishPathStoplist();
});
  
   events.subscribe('kiloList', () => {
    this.publishPathKilolist();
});
  
   events.subscribe('kiloList1', () => {
    this.publishPathKilo1list();
});
  
this.selectedV = this.navParams.get('group');
//this.selectedDeviceId = this.navParams.get('selectedDeviceId');
   // console.log("tabspage param groupe", this.selectedV);
    
    //console.log("tabspage param groupe", this.selectedDeviceId );

    //this.listMapTrajet(this.groupe, this.startdate,this.enddate,this.selectedDeviceId);
    if (this.selectedV){

      this.groupe = this.selectedV.group;
      console.log(this.groupe);
    this.selectedDeviceId = this.selectedV.selectedDeviceId;
      this.isCalled = true;
    }
    


    this.allGroups = this.realTimeService.getAllGroups("").subscribe(groupes => {
      this.data = groupes;
       console.log('isCalled',this.isCalled);
      if (!this.isCalled){
        this.groupe = this.data[0].idGroupe;
        this.selectedDeviceId = this.data[0].vehicules[0].device.idDevice;

      console.log('default selected device', this.selectedDeviceId);
      }
      console.log(this.groupe);
      console.log('liste', this.data);
       if (this.selectedV){
      this.matricule=this.data[this.selectedV.indexGroup].vehicules[this.selectedV.indexVehicule].matricule;
      this.vehicules=this.data[this.selectedV.indexGroup].vehicules;      
       }else{
      this.matricule=this.data[0].vehicules[0].matricule;
      this.vehicules=this.data[0].vehicules; 
       }
      
       this.initialized = true;
 
    if (this.initialized){
       //console.log(this.selectedDeviceId);
       this.listMapTrajet(this.groupe,this.startdate ,this.enddate,this.selectedDeviceId);
        if (this.section != 'trajet')
  {this.section = 'trajet';}
       //console.log(new Date());
      // console.log(this.stops);
      console.log("2",this.groupe);
  console.log("2",this.selectedDeviceId);
    }
    });







     }



refresh(){
  //this.navCtrl.setRoot(this.navCtrl.getActive().component);
}

 

updateMatricule(){
  console.log("1.5",this.defaultLoading);
  if (this.defaultLoading){
    console.log("2",this.defaultLoading);
     this.listMapTrajet(this.groupe, this.startdate,this.enddate,this.selectedDeviceId);
    if (this.section != 'trajet')
  {this.section = 'trajet';}
  }

}

  updateVehiculeList(){
    this.allGroups = this.realTimeService.getAllGroups("").subscribe(groupes => {
      this.data2 = groupes;
      console.log(this.groupe);
      for(let i =0;i<this.data2.length;i++){
      if (this.groupe == this.data2[i].idGroupe && this.defaultLoading){
        this.vehicules = this.data2[i].vehicules;
        console.log("exist");
        console.log("this.vehicules",this.vehicules);
        this.matricule = this.data2[i].vehicules[0].matricule;
         console.log(this.matricule);
        this.selectedDeviceId = this.data2[i].vehicules[0].device.idDevice;
         console.log("selectedDeviceId",this.selectedDeviceId);
     
      // this.listMapTrajet(this.groupe, this.startdate,this.enddate,this.selectedDeviceId);

     console.log("1",this.defaultLoading);

      }
      
    }
   
    });
    
    
     
  }


   ngOnInit() {

//listMapTrajet()
this.events.subscribe('showResult', selectedV => {
  this.isCalled = true;


    this.groupe = selectedV.group;
    this.selectedDeviceId = selectedV.selectedDeviceId;
  console.log(this.groupe.group);
  console.log(this.selectedDeviceId);
  //this.listMapTrajet(this.groupe,this.startdate,this.enddate,this.selectedDeviceId );
  
  this.initialized = true;

});

 //this.loadmap();
  


    }

MapListTrajet() {
  if (!this.case0){
     this.case0 = true;
     this.case1 = false;
     this.case2 = false;
  }

};

MapListArret() {
   if (!this.case1){
     this.case1 = true;
     this.case0 = false;
     this.case2 = false;
  }
};
MapListKilo() {
   if (!this.case2){
    this.case2 = true;
     this.case1 = false;
     this.case0 = false;
  }
 
};


  //get all paths
  /*getAllPaths() {
    this.viewCtrl.dismiss({
      startDate: this.startDate,
      endDate: this.endDate,
      list: this.list
    });
  }*/
// close modal
  closeModal() {
    this.viewCtrl.dismiss({
      startDate: "",
      endDate: "",
      list: ""
    });

  }

callOpenmenu(){
this.events.publish("openmenu");
}
//initMap

callInitMap(){
this.events.publish("initMap");
}

//remove polylines and markers from map
  clearPolylines() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.pathDrawn = false;
  }


  //open result "historique des trajets"
  openResultsModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    
    /*let pathsListModal = this.modalCtrl.create(PathsList, {
      paths: this.paths
    });*/
    if (this.paths == null && this.stops== null && this.mileages == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {

//this.events.publish('myEvent',myParam);
      this.publishPathTrajetlist();
      this.publishPathStoplist();
    }
  }

  // open modal "historique de kilometrage" result
  openMileageResultModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    /*let mileageListModal = this.modalCtrl.create(MileageComponent, {
      mileages: this.mileages,
      totalMileage: this.totalMileage
    });*/
    if (this.mileages == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {
     // mileageListModal.present();
     // mileageListModal.onDidDismiss(mileageClicked => {
       /* if (mileageClicked == null) {
          this.openFormModal();
        } else if (mileageClicked == 1) {

        } else this.drawMileage(mileageClicked);
*/


      }
    //this.resultopened = false;
    //this.openStopResult = false;
    //this.openMileageResult = true;
  }



  // open resultat des arrets
  openStopsResultsModal() {
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    /*let stopListModal = this.modalCtrl.create(StopList, {
      stops: this.stops
    });*/
    if (this.stops == null) {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Aucune informations',
        buttons: ['Ok']
      });
      alert.present();
    } else {
      /*stopListModal.present();
      stopListModal.onDidDismiss(stopClicked => {
        if (stopClicked == null) {
          this.openFormModal();
        } else if (stopClicked == 1) {

        } else this.drawStop(stopClicked);
      });*/

    }
    //this.resultopened = false;
    //this.openStopResult = true;
  }

publishPathTrajetlist(){
  this.events.publish("listPath",this.paths);
}

publishPathStoplist(){
  this.events.publish("listPathStop",this.stops);
}


publishPathKilolist(){
  this.events.publish("listPathKilo",this.mileages);
}
publishPathKilo1list(){
  this.events.publish("listPathKilo1",this.totalMileage);
}

//draw itineraire
  drawPath(path: Path) {

        if (this.pathClicked == null || this.pathClicked.beginPathTime != path.beginPathTime) {
            this.pathClicked = new Path();
            this.pathClicked = path;
        }

        this.historicalService.getPathDetails(this.selectedDeviceId, {
            startDate: path.beginPathTime,
            endDate: path.endPathTime
        }).subscribe(points => {

            //this.mapService.centerMap(points.coordinates, 12);

            let startHour: any = path.beginPathTime;
            let pathStartTime: any = startHour;
            path.displayBeginPathTime = pathStartTime;
            let endHour: any = path.endPathTime;
            let pathEndTime: any = endHour;
            path.displayEndPathTime = pathEndTime;
            let stopMarkers: Marker[] = [];
            points.stops.forEach(stop => {
                let popup = "<img src='" + this.imagesDir + "stop_smal.png" + "'/> Durée d'arrêt : " + stop.stopDurationStr;
                let stopMarker = new Marker({
                    lat: stop.stopLatitude,
                    lng: stop.stopLongitude
                });
                this.geocodingService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 18).subscribe(adress => {
                    let truncatedDisplayName = adress.display_name;
                    let countCommas = 0;
                    for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                            countCommas = countCommas + 1;
                        } else if (countCommas >= 4) {
                            truncatedDisplayName = adress.display_name.substring(0, i - 1);
                            break;
                        }
                    }
                    popup = popup + '<br><hr><b>' + truncatedDisplayName + '</b>';
                    stopMarker.bindPopup(popup);
                });
                stopMarker.setIcon(new Icon({
                    iconUrl: this.imagesDir + "stop_smal.png",
                    iconAnchor: [-1, 18],
                    popupAnchor: [10, -25]
                }));
                this.mapService.addMarker(stopMarker);
            });
            let polyline = L.polyline(points.coordinates, { color: '#0031D9', weight: 3 });
            points.coordinates.forEach((coordinate, i) => {
                let marker = new Marker(coordinate);
                if (i != 0 && i != points.coordinates.length - 1) {
                    marker.setIcon(new Icon({
                        iconUrl: this.imagesDir + "green-point.png",
                        iconAnchor: [2, 2]
                    }));
                    let pointTime: any = coordinate.date;
                    let coordinateTime: any = pointTime;
                    coordinate.date = coordinateTime;
                    var pointDatePipe = new DatePipe(coordinate.date);
                    let popup = '<b>Heure:</b> ' + pointDatePipe.transform(coordinate.date, 'dd/MM/yyyy HH:mm:ss') + '<b><br>vitesse:</b> ' + coordinate.speed + ' Km/h';
                    marker.bindPopup(popup);
                    marker.on('click', () => {
                        this.mapService.map.setView(coordinate, 17);
                    });
                    this.mapService.addMarker(marker);
                }
            });
            var startMarker = new Marker({ lat: path.beginPathLatitude, lng: path.beginPathLongitude });
            let startTime: any = path.displayBeginPathTime;
            var startDatePipe = new DatePipe(startTime);
            startMarker.bindPopup('<b> Lieu de début: </b>' + this.pathClicked.beginPathGeocoding + '<br><b> <i>[lat: </b>' + path.beginPathLatitude + '<b> ,long: </b>' + path.beginPathLongitude + '<b>]</i><br>Temps de debut du trajet : </b>' + startDatePipe.transform(startTime, 'dd/MM/yyyy HH:mm:ss'));
            startMarker.setIcon(new Icon({
                iconUrl: this.imagesDir + "startMarker.png",
                iconAnchor: [-2, 30],
                popupAnchor: [10, -25]
            }));
            this.mapService.addMarker(startMarker);
            if (path.endPathLatitude != null && path.endPathLongitude != null && path.endPathTime != null) {
                var endMarker = new Marker({ lat: path.endPathLatitude, lng: path.endPathLongitude });
                let endTime: any = path.displayEndPathTime;
                var endDatePipe = new DatePipe(endTime);
                endMarker.bindPopup('<b> Lieu de fin: </b>' + this.pathClicked.endPathGeocoding + '<br><i>[<b>lat:  </b>' + path.endPathLatitude + '<b>,long:  </b>' + path.endPathLongitude + ']</i><br><b>Temps de fin du trajet : </b>' + endDatePipe.transform(endTime, 'dd/MM/yyyy HH:mm:ss')
                    + '<br><b> Durée du trajet : </b>' + path.pathDurationStr + "<br><b> Durée d'arrêt : </b>" + path.nextStopDurationStr + "<br><b> Vitesse maximum : </b>"
                    + path.maxSpeed + " Km/h <br><b> Kilometrage parcouru : </b>" + path.distanceDriven.toFixed(2) + ' Km');
                endMarker.setIcon(new Icon({
                    iconUrl: this.imagesDir + "endMarker.png",
                    iconAnchor: [-2, 30],
                    popupAnchor: [10, -25]
                }));
                this.mapService.addMarker(endMarker);
            }
            this.mapService.addPolyline(polyline);
            var middle = points.coordinates[Math.round((points.coordinates.length - 1) / 2)];
            document.getElementById("save_path_button").classList.remove('hide');
            
            //map center offset(axis y)
            this.mapService.offsetMap(middle, 12, 0, -120);
        }, (err) => {
            
        });
    }





listMapTrajet(group:any,startDate:any,endDate:any,selectedDevice:any){
  let time_difference:number = this.globalService.gettime_difference();
   console.log(time_difference);
  if(this.paths ){
    this.paths = [];
  
  }
   if(this.stops ){
   
    this.stops = [];
  
  }
   if(this.mileages ){
    this.mileages = [];
  }

     this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
      this.loader.present();
      if(startDate == null && endDate == null){
        this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
      }
      //let firstDateTime = new Date(startDate);
      //let lastDateTime = new Date(endDate);

      this.allPaths = this.historicalService.getAllPaths(selectedDevice, {
            startDate: startDate,
            endDate: endDate
          }).subscribe(paths => {
           // console.log(paths);
             if (paths.length) {

               this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.paths = paths;
              let lastLat = paths[0].beginPathLatitude;
              let lastlng = paths[0].beginPathLongitude;
              let i = 0;
              this.paths.forEach(path => {

                if(path.beginPathLatitude != 0 && path.beginPathLongitude !=0){
                   let startHour: any = path.beginPathTime;
                //let start01 = new Date(startHour);
               // console.log(start01);
               
                let startTime: any = startHour + 0 * time_difference;
                // console.log(startTime);
                path.displayBeginPathTime = startTime;
                if (path.endPathTime != null) {
                  let endHour: any = path.endPathTime;
                 // let end01 = new Date(endHour);
                 // console.log(end01);
                  let endTime: any = endHour + 0 * time_difference;
                //  console.log(endTime);
                  path.displayEndPathTime = endTime;
                }
                path.beginPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.beginPathLatitude, path.beginPathLongitude);
                path.beginPathGeocoding = path.beginPathGeocodingDetails;
                if (path.beginPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.beginPathLatitude, path.beginPathLongitude, 17).subscribe(adress => {
                    path.beginPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.beginPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.beginPathGeocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.beginPathGeocoding = truncatedDisplayName;
                          path.beginPathGeocodingDetails = path.beginPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.beginPathGeocodingDetails = null;
                    path.beginPathGeocoding = null;
                  });
                }
                path.endPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.endPathLatitude, path.endPathLongitude);
                path.endPathGeocoding = path.endPathGeocodingDetails;
                if (path.endPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.endPathLatitude, path.endPathLongitude, 17).subscribe(adress => {
                    path.endPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.endPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.endPathGeocodingDetails = path.endPathGeocoding;
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.endPathGeocoding = truncatedDisplayName;
                          path.endPathGeocodingDetails = path.endPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.endPathGeocodingDetails = null;
                    path.endPathGeocoding = null;
                  });
                }
                i++;
                lastLat = path.beginPathLatitude;
                lastlng = path.beginPathLongitude;

                }
               
              });
              

            }
            //historique des arret
          this.allStops = this.historicalService.getAllStops(selectedDevice, {
            startDate: startDate,
            endDate: endDate
          }).subscribe(stops => {
            if (stops && stops.length) {
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.stops = stops;
              this.stops.forEach(stop => {
                stop.geocodingDetails = this.dataManagementService.getRelativePosition(stop.stopLatitude, stop.stopLongitude);
                stop.geocoding = stop.geocodingDetails;
                stop.beginStopTime = stop.beginStopTime + 0 * time_difference;
                if (stop.geocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 17).subscribe(adress => {
                    stop.geocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbourhood != null && adress.address.city != null) {
                      stop.geocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      stop.geocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          stop.geocoding = truncatedDisplayName;
                          stop.geocodingDetails = stop.geocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    stop.geocodingDetails = null;
                    stop.geocoding = null;
                  });
                }
              });
            }

             //historique kilometrage
          this.allMileages = this.historicalService.getAllMileages(selectedDevice, {
            startDate: startDate,
            endDate: endDate
          }).subscribe(mileages => {
            if(this.mileages){
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
            this.mapService.removeAllRtMarkers();
            this.history=true;
            }
            this.mileages = mileages;
            this.mileages.forEach(mileage => {
              let startHour: any = mileage.startHour;
              mileage.startHour = startHour + (60 * 60 * 1000);
              mileage.deviceId = selectedDevice;
            });
            this.totalMileage = this.mileages[this.mileages.length - 1];
            this.mileages.splice(this.mileages.length - 1);
            //this.loader.dismiss();
            //this.openMileageResultModal();
          }, (err) => {});
            /*this.loader.dismiss();
            this.openStopsResultsModal();*/
          }, (err) => {});
            this.loader.dismiss();
            this.defaultLoading = true;
            console.log(this.paths);
            this.openResultsModal();
           }, (err) => {});

        

           


        }

//openFormModal
 // historique des trajet + historique des stops + historique de kilometrage
  /*openFormModal() {
   
    if (this.selectedDevice) {
    
      let formModal = this.modalCtrl.create(HistoricalForm);
      formModal.present();
      formModal.onDidDismiss(form => {
        
        //historique des trajets
        if (form.endDate != "" && form.startDate != "" && form.list == "trajet") {
          let firstDateTime = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.allPaths = this.historicalService.getAllPaths(this.selectedDevice, {
            startDate: firstDateTime,
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(paths => {
            if (paths.length) {
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.paths = paths;
              let lastLat = paths[0].beginPathLatitude;
              let lastlng = paths[0].beginPathLongitude;
              let i = 0;
              this.paths.forEach(path => {
                let startHour: any = path.beginPathTime;
                let startTime: any = startHour + 2 * time_difference;
                path.displayBeginPathTime = startTime;
                if (path.endPathTime != null) {
                  let endHour: any = path.endPathTime;
                  let endTime: any = endHour + 2 * time_difference;
                  path.displayEndPathTime = endTime;
                }
                path.beginPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.beginPathLatitude, path.beginPathLongitude);
                path.beginPathGeocoding = path.beginPathGeocodingDetails;
                if (path.beginPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.beginPathLatitude, path.beginPathLongitude, 17).subscribe(adress => {
                    path.beginPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.beginPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.beginPathGeocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.beginPathGeocoding = truncatedDisplayName;
                          path.beginPathGeocodingDetails = path.beginPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.beginPathGeocodingDetails = null;
                    path.beginPathGeocoding = null;
                  });
                }
                path.endPathGeocodingDetails = this.dataManagementService.getRelativePosition(path.endPathLatitude, path.endPathLongitude);
                path.endPathGeocoding = path.endPathGeocodingDetails;
                if (path.endPathGeocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(path.endPathLatitude, path.endPathLongitude, 17).subscribe(adress => {
                    path.endPathGeocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbsourhood != null && adress.address.city != null) {
                      path.endPathGeocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      path.endPathGeocodingDetails = path.endPathGeocoding;
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          path.endPathGeocoding = truncatedDisplayName;
                          path.endPathGeocodingDetails = path.endPathGeocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    path.endPathGeocodingDetails = null;
                    path.endPathGeocoding = null;
                  });
                }
                i++;
                lastLat = path.beginPathLatitude;
                lastlng = path.beginPathLongitude;
              });

            }
            this.loader.dismiss();
            this.openResultsModal();
          }, (err) => {});
        }
        //historique des arret
        if (form.endDate != "" && form.startDate != "" && form.list == "arret") {
          let firstDateTime = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.allPaths = this.historicalService.getAllStops(this.selectedDevice, {
            startDate: firstDateTime,
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(stops => {
            if (stops && stops.length) {
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
              this.history=true;
              this.mapService.removeAllRtMarkers();

              this.stops = stops;
              this.stops.forEach(stop => {
                stop.geocodingDetails = this.dataManagementService.getRelativePosition(stop.stopLatitude, stop.stopLongitude);
                stop.geocoding = stop.geocodingDetails;
                stop.beginStopTime = stop.beginStopTime + 2 * time_difference;
                if (stop.geocodingDetails == null) {
                  this.geocodingService.inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 17).subscribe(adress => {
                    stop.geocodingDetails = adress.display_name;
                    if (adress.address.road != null && adress.address.neighbourhood != null && adress.address.city != null) {
                      stop.geocoding = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                      stop.geocodingDetails = adress.address.road + ' ' + adress.address.neighbourhood + '(' + adress.address.city + ')';
                    } else {
                      let truncatedDisplayName = adress.display_name;
                      let countCommas = 0;
                      for (var i = 0, len = adress.display_name.length; i < len; i++) {
                        if (adress.display_name[i] == ',') {
                          countCommas = countCommas + 1;
                        } else if (countCommas >= 5) {
                          truncatedDisplayName = adress.display_name.substring(0, i - 1);
                          stop.geocoding = truncatedDisplayName;
                          stop.geocodingDetails = stop.geocoding;
                          break;
                        }
                      }
                    }
                  }, (err) => {
                    stop.geocodingDetails = null;
                    stop.geocoding = null;
                  });
                }
              });
            }
            this.loader.dismiss();
            this.openStopsResultsModal();
          }, (err) => {});
        }

        //historique kilometrage
        if (form.endDate != "" && form.startDate != "" && form.list == "kilo") {
          let firstDateTime = new Date(form.startDate);
          let startHour: any = new Date(form.startDate);
          let lastDateTime = new Date(form.endDate);
          this.loader = this.loadingCtrl.create({
            content: "Veuillez attendre..."
          });
          this.loader.present();
          if (form.startDate == null && form.endDate == null) {
            this.loader.dismiss();
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: 'Informations erronées',
              buttons: ['Ok']
            });
            alert.present();
          }
          this.AllPaths = this.historicalService.getAllMileages(this.selectedDevice, {
            startDate: startHour - (24 * 60 * 60 * 1000),
            endDate: new Date(lastDateTime.getTime() + 3600000)
          }).subscribe(mileages => {
            if(this.mileages){
              this.pathpoirealtime = false;
              this.pathDrawn = false;
              this.previousPathdrawn = false;
              this.clearPolylines();
            this.mapService.removeAllRtMarkers();
            this.history=true;
            }
            this.mileages = mileages;
            this.mileages.forEach(mileage => {
              let startHour: any = mileage.startHour;
              mileage.startHour = startHour + (60 * 60 * 1000);
            });
            this.totalMileage = this.mileages[this.mileages.length - 1];
            this.mileages.splice(this.mileages.length - 1);
            this.loader.dismiss();
            this.openMileageResultModal();
          }, (err) => {});
        }
      });
    } else {
      let alert = this.alertCtrl.create({
        title: 'Historique',
        subTitle: 'Veuillez choisir un véhicule ',
        buttons: ['Ok']
      });
      alert.present();
    }
  }*/

ionViewDidEnter() {
    //this.loadmap();
  }
 
  loadmap() {
   
  }






    openCalendar() {
        this.myCalendar = this.modalCtrl.create(CalendarModalPage);
    
        this.myCalendar.present();

        this.myCalendar.onDidDismiss(range => {

          if (range == null){
            this.navCtrl.last();

          }else{

            console.log(range.startdate);
             console.log(range.endDate);
             
                  if(range.startdate==null && range.endDate == null){
             
            this.listMapTrajet(this.groupe, this.startdate,this.enddate,this.selectedDeviceId);
             if (this.section != 'trajet')
  {this.section = 'trajet';}
          }else{
          this.startdate = new Date(range.startdate);
          this.startdate.setDate( this.startdate.getDate());
          this.enddate = new Date(range.enddate);
          this.enddate.setDate( this.enddate.getDate()+1);
          this.listMapTrajet(this.groupe, this.startdate,this.enddate,this.selectedDeviceId);
           if (this.section != 'trajet')
  {this.section = 'trajet';}
          this.startdateShown = this.getStartDate(this.startdate.getDate());
          this.startmonthShown = this.getStartMonth(this.startdate.getMonth()+1);
          this.startyearShown = this.getStartYear(this.startdate.getUTCFullYear());
          this.enddateShown = this.getEndDate(this.enddate.getDate()-1);
          this.endmonthShown = this.getEndMonth(this.enddate.getMonth()+1);
          this.endyearShown = this.getEndYear(this.enddate.getUTCFullYear());
          console.log(this.startdateShown);
          console.log(this.startdate);
          console.log(this.enddate);
          }  
          }
               
          
    });
  }
  

  getStartYear(x) : string{
  return String(x);
}

getStartMonth(x) : string{
   let m : string = "0"+String(x);
    if ((x<10)){

    return m;
  }else{
    return String(x);
  }


  }

getStartDate(x) : string{
   let j : string = "0"+String(x);
   if(x<10){
    return  j;
}else{
  return String(x);
}
}

 getEndYear(x) : string{
  return String(x);
}

getEndMonth(x) : string{
   let m : string = "0"+String(x);
  // console.log(m);
    if ((x<10)){

    return m;
  }else{
    return String(x);
  }


  }

getEndDate(x) : string{
   let j : string = "0"+String(x);
   if(x<10){
    return  j;
}else{
  return String(x);
}
}

}


// WEBPACK FOOTER //
// ./src/pages/historical-form/historical-form.ts